import React from "react";

const BulkGiftPrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-40">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy for Gifter – Bulk Gift Cards Creator</h1>
      <p className="mb-4"><strong>Effective Date:</strong> 01-09-2025</p>
      <p className="mb-6">
        Thank you for using Gifter – Bulk Gift Cards Creator (“we,” “our,” “us,” or “the App”).
        We respect your privacy and are committed to protecting the personal information of all users
        who install and use our app.
      </p>

      <h2 className="text-2xl font-semibold mb-4">1. Information We Collect</h2>
      <p className="mb-2">When you install and use our app, we may collect the following information:</p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li><strong>Shop Information:</strong> Store name, store URL, Shopify domain, and Shopify Admin data required to create and manage gift cards.</li>
        <li><strong>Gift Card Data:</strong> Details uploaded through CSV (e.g., gift card amounts, recipient information if provided).</li>
        <li><strong>Usage Data:</strong> Information about how you interact with the app, such as feature usage and error logs.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">2. How We Use Information</h2>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Generate gift cards in bulk according to your CSV input.</li>
        <li>Ensure accurate and secure processing of data through Shopify’s systems.</li>
        <li>Provide support and resolve technical issues.</li>
        <li>Improve app functionality and user experience.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">3. Data Sharing</h2>
      <p className="mb-2">We do not sell, rent, or trade your information to third parties. Your data is only shared in the following cases:</p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li><strong>Shopify:</strong> As required to process gift cards securely through the Shopify platform.</li>
        <li><strong>Service Providers:</strong> Trusted third-party services that help us operate the app (e.g., hosting, analytics).</li>
        <li><strong>Legal Requirements:</strong> When required to comply with applicable laws or lawful government requests.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">4. Data Security</h2>
      <p className="mb-6">
        We take appropriate technical and organizational measures to protect your information from unauthorized access, disclosure, alteration, or destruction.
      </p>

      <h2 className="text-2xl font-semibold mb-4">5. Data Retention</h2>
      <p className="mb-6">
        We retain your information only as long as necessary to fulfill the purposes outlined in this Privacy Policy, or as required by law. You may request deletion of your data by contacting us.
      </p>

      <h2 className="text-2xl font-semibold mb-4">6. Your Rights</h2>
      <p className="mb-2">Depending on your location, you may have the right to:</p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Access, update, or delete your personal information.</li>
        <li>Restrict or object to certain types of processing.</li>
        <li>Request a copy of your stored data.</li>
      </ul>
      <p className="mb-6">To exercise these rights, please contact us at <a href="mailto:Support@mean3.com" className="text-blue-500 hover:underline">Support@mean3.com</a>.</p>

      <h2 className="text-2xl font-semibold mb-4">7. Changes to This Policy</h2>
      <p className="mb-6">
        We may update this Privacy Policy from time to time. Any changes will be posted with an updated effective date.
      </p>

      <h2 className="text-2xl font-semibold mb-4">8. Contact Us</h2>
      <p className="mb-6">
        If you have any questions about this Privacy Policy, please contact us at <a href="mailto:Support@mean3.com" className="text-blue-500 hover:underline">Support@mean3.com</a>.
      </p>
    </div>
  );
};

export default BulkGiftPrivacyPolicy;
